import { useSharedMediaApi } from '@/features/api/hooks/shared-media/useSharedMediaApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useDeleteTemporaryMediaItem = () => {
  const api = useSharedMediaApi();

  return useApiMutation({
    mutationFn: (temporaryMediaItemId: string) =>
      api.deleteTemporaryMediaItem({ temporaryMediaItemId })
  });
};
